
import { persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/es/storage' // default: localStorage if web, AsyncStorage if react-native


//-- Smart Reducers
import { UserReducer } from './UserReducer';
import { SnackbarReducer } from './SnackbarReducer';
import { ClientPathReducer } from './ClientPathReducer';
import { AddressReducer } from './AddressReducer';
import { SearchDataReducer } from './SearchDataReducer';
import { reportReducer } from './reportReducer';
import { messagesReducer } from './messagesReducer';
import { AppReducer } from './AppReducer';

const config = {
  key: 'root',
  storage,
} 

const rootReducer = persistCombineReducers(config, {
  AddressReducer,
  UserReducer,
  SnackbarReducer,
  ClientPathReducer,
  SearchDataReducer,
  reportReducer,
  messagesReducer,
  AppReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js